<template>
  <div id="mainIndex">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'mainIndex'
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/common/Main.vue